import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: "Dashboard",
		url: "/dashboard",
		icon: "dashboard",
	},
	{
		name: "Image compression",
		url: "/image_compression",
		icon: "file-image-o",
	},
];

export default class Image_Compression extends Framework.Components.View {
	constructor(props) {
		super(props, "details");
	}

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history} />

				<Objects.ImageCompression
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
				/>
			</div>
		);
	}
}
